module.exports = __webpack_public_path__ + "static/img/pumpkin_dark@2x.d128873.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pumpkin_dark@2x.png
// module id = ChhP
// module chunks = 0